<div class="kpi" [ngClass]="data.variant">
  <div class="kpi-top">
    @if (data.iconSrc || data.iconClass) {
      <div class="kpi-icon">
        @if (data.iconSrc) {
          <span class="kpi-icon-svg" [innerHTML]="iconHtml$ | async"></span>
        }
        @if (data.iconClass) {
          <i class="pi {{ data.iconClass }}"></i>
        }
      </div>
    }

    <div class="dash-pills">
      @if (data.pill) {
        <span class="dash-pill">{{ data.pill }}</span>
      }
    </div>
  </div>
  <div class="kpi-label">{{ data.label }}</div>
  <div class="kpi-value">{{ data.value }}</div>
  @if (data.sub || data.progressValue != null) {
    <div class="flex justify-content-between align-items-center kpi-sub">
      @if (data.sub) {
        <span [innerHTML]="data.sub"></span>
      }
      @if (data.progressValue != null) {
        <span>{{ data.progressValue | number:'1.1-1' }}%</span>
      }
    </div>
  }

  @if (data.progressValue != null) {
    <p-progressBar [value]="data.progressValue" [showValue]="false" class="kpi-progress-bar"/>
  }
</div>
